export const legalQueryKeys = {
  all: ['legal'] as const,
  documents: () => [...legalQueryKeys.all, 'documents'] as const,
  termsAcceptance: (tenantId: string | undefined) =>
    [...legalQueryKeys.all, 'terms-acceptance', tenantId] as const,
  candidateNotices: (tenantId: string | undefined) =>
    [...legalQueryKeys.all, 'candidate-notices', tenantId] as const,
};
